module.exports = __webpack_public_path__ + "img/AT0000016293878.11a195e1.png";